import {
  type ContactFormValues,
  directContactFormMakeDefaultValues,
} from '../../../direct-contact'

type SelectedProduct = {
  itemName: string
  key: string
  pzn: string
  totalCost: number
}

export type DirectContactFormValues = ContactFormValues & {
  selectedProducts: SelectedProduct[]
}

export const DIRECT_CONTACT_FORM_DEFAULT_VALUES: DirectContactFormValues = {
  ...directContactFormMakeDefaultValues(),
  selectedProducts: [],
}
